import React from "react";

const METRICS = [
  { key: "monthly", label: "MAU", field: "monthly_active_users", growthField: "monthly_growth", color: "#8B5CF6" },
  { key: "weekly", label: "WAU", field: "weekly_active_users", growthField: "weekly_growth", color: "#EC4899" },
  { key: "daily", label: "DAU", field: "daily_active_users", growthField: "daily_growth", color: "#1FAF5C" },
];

const StatsCards = ({ stats, trendsData, isLoading, error }) => {
  if (isLoading) {
    return (
      <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
        {[1, 2, 3].map((i) => (
          <div key={i} className='bg-white rounded-2xl border border-border-subtle p-5 animate-pulse'>
            <div className='h-3 bg-surface-neutral-subtle rounded w-16 mb-3' />
            <div className='h-7 bg-surface-neutral-subtle rounded w-12 mb-2' />
            <div className='h-3 bg-surface-neutral-subtle rounded w-20' />
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className='bg-white rounded-2xl border border-border-subtle p-5'>
        <p className='text-body-sm text-severity-high'>Failed to load stats</p>
      </div>
    );
  }

  if (!stats) return null;

  const getAverage = (data) => {
    if (!data || data.length === 0) return "—";
    const sum = data.reduce((acc, item) => acc + item.active_users, 0);
    return (sum / data.length).toFixed(1);
  };

  const trendSources = {
    monthly: trendsData?.monthly_users,
    weekly: trendsData?.weekly_users,
    daily: trendsData?.daily_users,
  };

  return (
    <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
      {METRICS.map((m) => {
        const value = stats[m.field];
        const growth = stats[m.growthField];
        const avg = getAverage(trendSources[m.key]);

        return (
          <div key={m.key} className='bg-white rounded-2xl border border-border-subtle p-5'>
            <p className='text-body-xs font-medium text-text-secondary mb-1'>{m.label}</p>
            <div className='flex items-baseline gap-2'>
              <span className='text-metric' style={{ color: m.color }}>{value ?? "—"}</span>
              {growth != null && (
                <span className={`text-body-xs font-semibold ${growth >= 0 ? "text-accent-green" : "text-severity-high"}`}>
                  {growth >= 0 ? "+" : ""}{growth.toFixed(1)}%
                </span>
              )}
            </div>
            <p className='text-caption text-text-tertiary mt-1'>Avg: {avg}</p>
          </div>
        );
      })}
    </div>
  );
};

export default StatsCards;
